import {decorate, inject, injectable} from '@yosmanyga/di';
import {AxiosInstance} from './Axios';

class ProfileApi {
    constructor(private axios: AxiosInstance) {
    }

    gatherProfile = async (): Promise<{ version: string }> => {
        const {data}: { data: { version: string } } = await this.axios
            .withAuthentication()
            .get('/v1/gather-profile');

        return data
    };
}

decorate(injectable(), ProfileApi);
decorate(inject(AxiosInstance), ProfileApi, 0);

export {ProfileApi};
